import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Notfound.css';

const notfound = '/assets/Notfound.svg';
const Notfound = () => {
    let Navigate = useNavigate();
    return (
        <>
            <div className='ErrorSection'>
                <div>
                    <div className='Error_Div1'>
                        <h1>404</h1>
                        <h3>Page not Found</h3>
                        <h2>We Couldn't find the page you are looking for</h2>
                        <button onClick={() => Navigate('/login')}>
                            Back To Home
                        </button>
                    </div>
                    <div className='Error_Div2'>
                        <img src={notfound} className='img1' alt='' />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notfound;
